const messages = {
  title: "Min profil",
  desc: "Velkommen til ditt personlige område. Her kan du oppdatere eller justere <br/>opplysningene dine og sjekke innboksen din.",
  descStaff:
    "Velkommen til ditt personlige område. Her kan du oppdatere eller justere opplysningene dine.",
  buttons: {
    showProfile: "Vis profil",
    userProfile: "GÅ TIL STAMDATA",
    mailbox: "GÅ TIL INNBOKS",
    addNewEmail: "Legg til ny e-post",
  },
  categories: {
    baseData: {
      title: "Stamdata",
      desc: "Fyll inn dine personlige og selskapsdata for riktig registrering.",
    },
    mailbox: {
      desc: "Motta viktige varsler og nyheter i innboksen din.",
    },
    bankstatement: {
      title: "Kontoutskrift",
      desc: "Her kan du sjekke statusen på din personlige Bridgestone Plus-konto og se opptjente og brukte premiepoeng.",
    },
  },
  profile: {
    general: "PERSONOPPLYSNINGER SELSKAPSOPPLYSNINGER",
    title: "Stamdata",
    description:
      "Velkommen til ditt personlige område. Her kan du oppdatere eller justere opplysningene dine.",
    block_description:
      "Velkommen til ditt personlige område. Her kan du se opplysningene dine",
    personalData: "PERSONOPPLYSNINGER",
    password: "Passord",
    password1: "Passord (valgfritt)*",
    password2: "Passord (gjenta)*",
    formOfAddress: "Tittel",
    choose: "Velg tittel",
    mr: "Hr.",
    mrs: "Fr.",
    diverse: "Annet",
    firstname: "Fornavn",
    surname: "Etternavn",
    position: "STILLING I SELSKAPET",
    operatingData: "SELSKAPSDATA",
    company: "Selskap",
    legalForm: "Rettsform",
    name: "Navn",
    streetHouseNr: "Selskapsadresse",
    street: "Gate",
    postcode: "Postnummer",
    location: "Sted",
    country: "Land",
    de: "Tyskland",
    at: "Østerrike",
    ch: "Sveits",
    nl: "Nederland",
    it: "Italia",
    language: "Språk",
    french: "Fransk",
    italian: "Italiensk",
    german: "Tysk",
    nederland: "Nederlandsk",
    phone: "Telefon",
    website: "Nettsted",
    operatingIndicators: "Nøkkeltall",
    tireSale: "Årlig dekksalg ca. i enheter",
    tireSaleLabel: "Selger dekk i store volum",
    inches: "Derav ≥ 18 tommer (i %)",
    inchesLabel: "Derav 18 tommer eller mer i %",
    segmentSale: "Dekksalg etter segment (andel Budget / Mid / Premium i %)",
    premBudget: "Premium",
    midBudget: "Middels",
    budBudget: "Budget",
    distribution: "FORDELING SOMMER / VINTER / ALLSESONG (i %)",
    summerIn: "Sommer i",
    winterIn: "Vinter i",
    allSeasonIn: "All sesong i",
    tyreSizes: "Antall sesonglagringsplasser (dekksett)",
    diffDeliveryAddres: "Legg til leveringsadresse",
    yourEmailAddress: "Din e-postadresse.",
    clientNr: "Kundenumre",
    clientNrSingular: "Kundenummer",
    clientNrContent:
      "<span class='text-danger fw-bold'>VIKTIG – VENNLIGST LES:</span><br /><br /> For riktig tilordning av dekkkjøpene dine til en grossist og/eller Bridgestone er det nødvendig å <b>oppgi dine respektive kundenumre.</b><br/><br/>Hvis du har <b>flere kundenumre hos en grossist og/eller Bridgestone,</b> f.eks. for hovedbutikken og underavdelinger, vennligst oppgi hovedbutikkens kundenummer først.<br/><br/><b>Salg fra andre kundenumre tilordnes deretter hovedbutikken din.</b>",
    supplySource: "Leveringskilde",
    email: "E-postadresse",
    staffEmail: "Deltakerens e-postadresse",
    registered: "Registrert",
    registeredAt: "Registrert",
    lastLogIn: "Sist innlogget",
    details: "Detaljer",
    inDetail: "{name} i detalj",
    customerFile: "Kundekort",
    customerHistory: "Kundhistorikk",
    currentYear: "Inneværende år",
    bsClientNr: "Ditt Bridgestone-kundenummer",
    bftClientNr: "Ditt Best4Tires-kundenummer",
    acceptTerms: "Godta vilkår og betingelser for deltakelse.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>VIKTIG – VENNLIGST LES:</span><br />Ved første registrering av kundenumre kontrolleres opplysningene dine for riktighet og overensstemmelse med våre distribusjonskriterier. Beslutningen om å aktivere kundenummer(ne) og knytte dem til profilen din kan ta opptil 5 arbeidsdager.",
    selectWholeSaler: "hos leverandør (vennligst velg)",
    cooperation: "MEDLEMSKAP / SAMARBEID",
    error100: "Summen av verdiene må være 100 %.",
    errorRange: "Verdien må være mellom 0 og 100",
    btw_number_label: "Selskapets mva-registreringsnummer",
    btw_number: "Mva-registreringsnummer",
    mobile: "Telefonnummer",
    mobile_label: "Ditt mobiltelefonnummer",
    iban_number: "Selskapets IBAN-nummer",
    iban_number_label: "IBAN-nummer",
    iban_must_be_16_digits: "IBAN må være nøyaktig 16 sifre.",
    iban_min_16_digits: "IBAN må ha minst 16 sifre.",
    yourCsNr: "Dine kundenumre",
    yourLastName: "Ditt etternavn",
    positionLabel: "Velg en stilling",
    yourFirstName: "Ditt fornavn",
    companyLabel: "Selskap",
    numberOfSetsOfSeasonalTiresBudget: "Årlig lagring",
    contactInfo: "Har du spørsmål, vennligst kontakt oss: {email}",
    addAnotherCsNumber: "Legg til et Bridgestone-kundenummer til",
    activityAndProfile: "FORRETNINGSDRIKTIGHET OG PROFIL",
    financialEmail: "Økonomiske e-poster",
    indirectCustomNumberHelpMessage:
      "Vi kunne ikke oppdage konfigurasjonen av kundenummeret ditt. Vennligst sjekk profilen din og bekreft om du er en direkte eller indirekte kunde for å fortsette.",
    completeProfile: "Fullfør den personlige profilen din og",
    completeProfileBold: "sikre deg 200 poeng.",
    city: "Sted",
  },
  countries: {
    al: "Albania",
    ad: "Andorra",
    at: "Østerrike",
    be: "Belgia",
    by: "Hviterussland",
    ba: "Bosnia-Hercegovina",
    bg: "Bulgaria",
    hr: "Kroatia",
    cy: "Kypros",
    cz: "Tsjekkia",
    dk: "Danmark",
    ee: "Estland",
    fi: "Finland",
    fr: "Frankrike",
    ge: "Georgia",
    gr: "Hellas",
    es: "Spania",
    nl: "Nederland",
    ie: "Irland",
    is: "Island",
    kz: "Kasakhstan",
    xk: "Kosovo",
    li: "Liechtenstein",
    lt: "Litauen",
    lu: "Luxembourg",
    lv: "Latvia",
    mk: "Nord-Makedonia",
    mt: "Malta",
    md: "Moldova",
    mc: "Monaco",
    de: "Tyskland",
    no: "Norge",
    pl: "Polen",
    pt: "Portugal",
    ru: "Russland",
    ro: "Romania",
    sm: "San Marino",
    rs: "Serbia",
    sk: "Slovakia",
    si: "Slovenia",
    se: "Sverige",
    ch: "Sveits",
    tr: "Tyrkia",
    ua: "Ukraina",
    hu: "Ungarn",
    gb: "Storbritannia",
    it: "Italia",
    va: "Vatikanstaten",
  },
  addCsNumber: {
    title: "Merknad",
    body: "Er du sikker på at du vil lagre dette kundenummeret? Handlingen sperrer redigeringsdata inntil administratoren godkjenner det.",
  },
  extraEmailSection: {
    description:
      "Ekstra e-postadresser brukes utelukkende til å sende BS+ markedsføringsinformasjon og/eller økonomisk informasjon og skal <b>under ingen omstendigheter brukes til innlogging eller administrasjon</b> av Bridgestone PLUS-kontoen.",
    optionOne: "For økonomisk info (f.eks. bonusspecifikasjon)",
    optionTwo:
      "For Bridgestone Plus markedsføringskommunikasjon (f.eks. kampanjer/nyhetsbrev)",
    addNewEmail: "Legg til ny e-postadresse",
  },
};

export default {
  messages,
};
